import DOMPurify from "dompurify";
import { marked } from "marked";

const isHtml = (str) => /<[a-z][\s\S]*>/i.test(str || "");

// CSS properties we allow through from the rich text editor
const SAFE_STYLE_PROPS = new Set(["text-align", "color"]);

// Sanitize config — allow the tags Tiptap and marked produce
const PURIFY_CONFIG = {
  ALLOWED_TAGS: [
    "p", "br", "strong", "em", "b", "i",
    "h2", "h3", "h4",
    "ul", "ol", "li",
    "blockquote", "hr",
    "a", "span",
  ],
  // style: needed for Tiptap text-align and color inline styles
  // class: needed for any Tiptap class-based alignment fallbacks
  ALLOWED_ATTR: ["href", "target", "rel", "style", "class"],
};

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A") {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }
  // Strip any unsafe CSS — keep only text-align and color
  if (node.hasAttribute("style")) {
    const filtered = (node.getAttribute("style") || "")
      .split(";")
      .map(s => s.trim())
      .filter(s => {
        const prop = s.split(":")[0]?.trim().toLowerCase();
        return prop && SAFE_STYLE_PROPS.has(prop);
      })
      .join("; ");
    filtered ? node.setAttribute("style", filtered) : node.removeAttribute("style");
  }
});

function sanitize(html) {
  if (typeof window === "undefined") return html; // SSR safety
  return DOMPurify.sanitize(html, PURIFY_CONFIG);
}

export default function RichTextRenderer({ content }) {
  if (!content) return null;

  let html;
  if (isHtml(content)) {
    html = sanitize(content);
  } else {
    // Fallback: render markdown/plain text via marked
    html = sanitize(String(marked.parse(content)));
  }

  return (
    <div
      className="rich-content"
      data-testid="deal-description"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
